import { getLocalTimeZone, today } from '@internationalized/date'
import { addDays, format, parseISO } from 'date-fns'

import { CriadorParcelasBase } from '@/domain/simulador/criador-parcelas-base'
import type { TGrupoParcelas } from '@/utils/calculadora-valores-totais/processador-valores-decimal'

export type TSimulacaoParcela = { data: string; valor: number }

export class GerenciadorEntradasBase {
  criarGrupoInicial(
    datasSinais: string[],
    valorSinal: number = 0,
    ato?: { data: string; valor: number },
  ): TGrupoParcelas {
    const parcelasAto = this.criarAto(ato)
    const parcelasSinais = this.criarSinais(datasSinais, valorSinal)

    return [...parcelasAto, ...parcelasSinais]
  }

  private criarAto(ato?: { data: string; valor: number }): TSimulacaoParcela[] {
    if (!ato?.data || !ato?.valor) return []
    return [CriadorParcelasBase.criar(ato.data, ato.valor)]
  }

  private criarSinais(datasSinais: string[], valor: number): TSimulacaoParcela[] {
    if (!valor || !datasSinais?.length) return []
    return datasSinais.map((data) => CriadorParcelasBase.criar(data, valor))
  }

  criarProximaEntrada(entradas?: TGrupoParcelas): TSimulacaoParcela {
    const dataUltimaEntrada = parseISO(entradas?.at(-1)?.data ?? today(getLocalTimeZone()).toString())
    const diasParaAcrescentar = entradas?.length ? 1 : 0
    const proximaData = format(addDays(dataUltimaEntrada, diasParaAcrescentar), 'yyyy-MM-dd')

    return CriadorParcelasBase.criar(proximaData)
  }
}
